import { Suspense, lazy, useEffect, useState } from 'react';

// Libraries
import { Routes, Route, useLocation } from 'react-router-dom';
import retina from 'retinajs';
import { AnimatePresence } from 'framer-motion';
import { HelmetProvider } from 'react-helmet-async';

// Context
import GlobalContext from './Litho/Context/Context';

// Components
import ScrollToTopButton from './Litho/Components/ScrollToTop';

import 'react-toastify/dist/ReactToastify.css';

import { ToastContainer } from 'react-toastify';

// const Litho = lazy(() => import('./Litho'));
const HomePage = lazy(() => import('./Pages/HomePage'));
const HistoryPage = lazy(() => import('./Pages/HistoryPage'));
const ArtWorkPage = lazy(() => import('./Pages/ArtPage'));
const AlbumPage = lazy(() => import('./Pages/AlbumPage'));
const ServiceRoutes = lazy(() => import('./Pages/Services/ServiceRoutes'));
const ContactPage = lazy(() => import('./Pages/ContactPage'));
const GalleryPage = lazy(() => import('./Pages/GalleryPage'));
const PageNotFoundPage = lazy(() => import('./Pages/PageNotFoundPage'));

function App() {
	const [headerHeight, setHeaderHeight] = useState(0);
	const [footerHeight, setFooterHeight] = useState(0);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [customModal, setCustomModal] = useState({
		el: null,
		isOpen: false,
	});
	const location = useLocation();

	// RetinaJS
	useEffect(() => {
		const initRetina = () => retina(document.querySelectorAll('img'));
		window.addEventListener('load', initRetina);
		initRetina();

		return () => {
			window.removeEventListener('load', initRetina);
		};
	}, []);

	useEffect(() => {
		import('./Litho/Functions/Utilities').then((module) => {
			module.SetHeaderMenuPos();
			module.setDocumentFullHeight();
		});
	}, [location.pathname]);

	useEffect(() => {
		if (isModalOpen === true) {
			document.querySelector('body').classList.add('overflow-hidden');
		} else {
			document.querySelector('body').classList.remove('overflow-hidden');
		}
	}, [isModalOpen]);

	// Get the current location and set the window to top
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'instant',
		});
		setFooterHeight(0);
		setCustomModal((prev) => ({
			...prev,
			el: null,
			isOpen: false,
		}));
	}, [location]);

	return (
		<HelmetProvider>
			<GlobalContext.Provider
				value={{
					headerHeight,
					setHeaderHeight,
					footerHeight,
					setFooterHeight,
					isModalOpen,
					setIsModalOpen,
					customModal,
					setCustomModal,
				}}
			>
				<div
					className='App bg-tsecondary'
					style={{ '--header-height': `${headerHeight}px` }}
				>
					{
						<main
							style={{ marginTop: headerHeight, marginBottom: footerHeight }}
						>
							<ScrollToTopButton />
							<AnimatePresence mode='wait'>
								<Suspense fallback={<></>}>
									<Routes>
										{/* <Route path='litho/*' element={<Litho />} /> */}
										<Route path='/' element={<HomePage />} />
										<Route path='/history' element={<HistoryPage />} />
										<Route path='/artwork' element={<ArtWorkPage />} />
										<Route path='/design-and-meaning' element={<AlbumPage />} />
										<Route path='/services/*' element={<ServiceRoutes />} />
										<Route path='/contact-us' element={<ContactPage />} />
										<Route path='/gallery' element={<GalleryPage />} />

										<Route path='/*' element={<PageNotFoundPage />} />
									</Routes>
									<ToastContainer
										position='top-center'
										autoClose={3000}
										hideProgressBar={false}
										newestOnTop={false}
										closeOnClick
										rtl={false}
										pauseOnFocusLoss
										draggable={false}
										pauseOnHover={false}
										theme='dark'
									/>
								</Suspense>
							</AnimatePresence>
						</main>
					}
				</div>
			</GlobalContext.Provider>
		</HelmetProvider>
	);
}

export default App;
